export default __webpack_public_path__ + "static/media/neck-yellow.2df0766c.png";